import { useParams } from 'react-router-dom';
import { useEntityUrl } from 'framework/routing';
import { VACANCY_PUBLICATION_PATH } from 'domain/recruiting/vacancy/publication/shared/vacancyPublicationService';

export const useVacancyPublicationUrl = () => {
  const { getCreateUrl: baseGetCreateUrl, ...baseUrls } = useEntityUrl({ baseLink: VACANCY_PUBLICATION_PATH });
  const getCreateUrl = (vacancyId: string) => `${baseGetCreateUrl()}?vacancyAlias=${vacancyId}`;

  return { ...baseUrls, getCreateUrl };
};

export const useVacancyPublicationId = () => {
  const { id } = useParams<Dictionary<string>>();
  return id;
};
